import debounce from 'lodash.debounce';
import { useCallback } from 'react';

export function useDebounceCallback(logic, dependencies = [], wait = 300) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(logic, wait), dependencies);
}

export default useDebounceCallback;
